export default {
  'en': {
    'common.and': 'and',
    'common.bid': 'bid',
    'common.bids_few': 'bids',
    'common.bids_many': 'bids',
    'common.day': 'day',
    'common.days_few': 'days',
    'common.days_many': 'days',
    'common.foundation_instrumental_case': 'foundation',
    'common.foundations_instrumental_case': 'foundations',
    'common.foundations_instrumental_case-charity': 'charitable foundations',
    'common.hour': 'hour',
    'common.hours_few': 'hours',
    'common.hours_many': 'hours',
    'connect.subtitle': 'To connect your fund to the platform and get the opportunity to place lots, fill out the questionnaire. We will review it within 7 working days.',
    'connect.thanks_for': 'Thanks for your application!',
    'connect.we_contact': 'Your profile will be reviewed within 7 working days, if it is approved or if you have any questions, we will contact you.',
    'connect.go_main': 'Go to Main page',
    'connect.send': 'Send a questionnaire',
    'connect.have_errors': 'You have an errors in form',
    'connect.application': 'Fund connection questionnaire',
    'connect.step': 'Step',
    'connect.general_information': 'General information about the fund',
    'connect.representative': 'Representative contacts',
    'connect.entity': 'Legal information',
    'connect.suggested_lots': 'Your list of potential lots',
    'hero.for_charity': 'for charity',
    'hero.good_excuse': 'We offer new ways to participate in charity, turning it into a unique experience. Here you don`t just help - you gain new experiences and inspiring communication with outstanding people!',
    'profile_report.report_sent': 'Your report was successfully sent!',
    'profile_report.report_about': 'Report about your meeting with',
    'profile_report.your_impressions': 'Your impressions',
    'profile_report.error': 'Something went wrong, please try again later...',
    'profile_report.send': 'Send',
    'profile_report.delete_photo': 'Delete photo',
    'profile_report.delete_approval_form': 'Delete approval',
    'profile_report.add_photo': 'Add photo',
    'profile_report.you_must_fill': 'You must fill in the text of the report',
    'profile_edit.back': 'BackВве',
    'profile_edit.save': 'Save info',
    'profile_edit.login': 'Change phone number',
    'profile_edit.name': 'Name',
    'profile_edit.middlename': 'Middlename',
    'profile_edit.surname': 'Surname',
    'profile_edit.field_required': 'The field is not filled in',
    'profile_edit.invalid_date': 'Invalid date',
    'profile_edit.phone_format': 'Phone number should take the format: 7ХХХХХХХХХХ',
    'profile_edit.email_format': 'Email should take the format: something@example.com',
    'profile_edit.preferred_methods': 'Preferred communication methods',
    'profile_edit.birthday': 'Birthday',
    'profile_edit.birthday.0': 'January',
    'profile_edit.birthday.1': 'February',
    'profile_edit.birthday.2': 'March',
    'profile_edit.birthday.3': 'April',
    'profile_edit.birthday.4': 'May',
    'profile_edit.birthday.5': 'June',
    'profile_edit.birthday.6': 'July',
    'profile_edit.birthday.7': 'August',
    'profile_edit.birthday.8': 'September',
    'profile_edit.birthday.9': 'October',
    'profile_edit.birthday.10': 'November',
    'profile_edit.birthday.11': 'December',
    'profile_edit.passport': 'Passport:',
    'profile_edit.month': 'Month',
    'profile_edit.day': 'day',
    'profile_edit.email': 'E-mail',
    'profile_edit.phone': 'Phone',
    'profile_edit.sms': 'SMS',
    'profile_edit.telegram': 'Telegram',
    'profile_edit.whatsapp': 'WhatsApp',
    'profile_edit.telegramId': 'Telegram ID',
    'profile_edit.telegramName': 'Telegram - Username',
    'profile_sidebar.you_donated': 'You donated',
    'profile_sidebar.you_supported': 'You supported',
    'profile_sidebar.you_did_not_donate': 'You did not<br />donate anything',
    'profile_sidebar.unpaid_lots': 'Unpaid lots',
	  'profile_sidebar.paid_fixedpricelots': 'Paid lots',
    'profile_sidebar.pay': 'Pay',
    'profile_sidebar.pay_button': 'Make bid',
    'profile_sidebar.not_won': 'It seems that you have not yet won a single auction. It is time to make your winning bid and support those who need it most!',
    'person_profile.birthday': 'Birthday',
    'person_profile.birthday.0': 'January',
    'person_profile.birthday.1': 'February',
    'person_profile.birthday.2': 'March',
    'person_profile.birthday.3': 'April',
    'person_profile.birthday.4': 'May',
    'person_profile.birthday.5': 'June',
    'person_profile.birthday.6': 'July',
    'person_profile.birthday.7': 'August',
    'person_profile.birthday.8': 'September',
    'person_profile.birthday.9': 'October',
    'person_profile.birthday.10': 'November',
    'person_profile.birthday.11': 'December',
    'person_profile_sidebar.you_did_not_support': 'You have not supported the funds yet',
    'person_data_form.not_agree_comment': 'If you do not agree',
    'claim.become_participant': 'Offer a lot',
    'claim.application_accepted': 'Your application has been accepted!',
    'claim.few_words': 'Write a few words about yourself',
    'claim.write_about': 'Write about yourself',
    'claim.send': 'Send',
    'claim.error': 'Something went wrong, try again later...',
    'help.donation_notice': 'Thank you for your donation',
    'help.donation_text': 'Thank you for your donation',
    'help.whom': 'To whom are we grateful',
    'help.help': 'Help!',
    'select.subject': 'Subject of message',
    'header.auctions': 'Auctions',
    'header.arts': 'Art',
    'header.about.me': 'About me',
    'header.ducuments': 'Documents',
    'header.reporting': 'Reporting',
    'header.visits': 'Visits',
    'header.fixedprices': 'Fix lots',
    'header.help': 'Help!',
    'header.foundations': 'Foundations',
    'header.participants': 'Participants',
    'header.news': 'News',
    'header.massmedia': 'Mass media',
    'header.contacts': 'Contacts',
    'header.giftcard': 'Gift Card',
    'header.become_participant': 'Offer a lot',
    'header.settings': 'Settings',
    'header.profile': 'Profile',
    'header.logout': 'Logout',
    'header.login': 'Login',
    'header.aboutus': 'About us',
    'timer.repeat_in': 'We have sent you a confirmation code on your login. You can request another code in',
    'timer.resend': 'Send another code',
    'timer.back': 'Back',
    'timer.auction_finish': 'Auction finishes in',
    'timer.auction_completed': 'Auction completed',
    'sidebar_share.share': 'Share:',
    'sidebar_share.vk': 'VK',
    'sidebar_share.twitter': 'Twitter',
    'form.send': 'Send',
    'preview_list.we_have': 'We have partnerships with more than',
    'preview_list.among_them': 'among them',
    'preview_list.see_all': 'See all Foundations',
    'bid_history.you': 'You',
    'bid_history.show_more': 'Show more',
    'bid.bid_sent': 'Your bid was successfully entered!',
    'bid.bid_fail': 'Bid error',
    'bid.bid_na': 'Bids not available',
    'bid.make_bid': 'Make a bid',
    'bid.make_purchase': 'Get a lot',
    'bid.lot': 'Lot',
    'bid.login_required': 'First login to your account',
    'bid.bid': 'Bid',
    'bid.error': 'Something went wrong, try again later...',
    'bid.make_bid_anonymously': 'Place a bid anonymously',
    'bid.follow_auction': 'Follow this auction',
    'bid.choose_bid': 'Choose your bid',
    'bid.invalid_giftcard': 'Choose valid gift card',
    'bid.accept_agreements': 'Agree to the terms of the Offer and the Terms of Use of the certificate',
    'bid.accept_agreements_offer': 'Agree to the terms of the Offer',
    'bid.accept_agreements_giftcards': ' and the Terms of Use of the certificate',
    'bid.choose_payment_method': 'Choose your payment method',
    'bid.bid_too_small': 'Your bid cannot be any less than',
    'bid.bid_recommendation':'The bid must be at least',
    'bid.agreement_title': 'Dear customer!',
    'bid.agreement_text': 'When you link the card, a small amount of money (no more than 2 rubles) will be debited from you, which will be returned later, at the same time the specified amount for the purchase will be debited.',
    'bid.proceed': 'Continue',
    'bid.select_payment': 'Select payment method',
    'bid.charge_only_win_bid': '*Payment is charged only for the winning bid after the end of the auction',
    'bid.we_become_better': 'We are getting better for you.',
    'bid.new_payment_method': 'Therefore Meet For Charity is switching to the new payment method. Add card and pay a lot quick and easy.',
    'bid.make_payment': 'Make donation',
    'bid.select_card': 'Select card',
    'bid.zero_giftcard': 'Gift card has zero balance',
    'bidPayment.confirm_delete_card': 'Are you sure you want to delete the linked card?',
	  'bidPayment.confirm_pay_from_card': 'Are you sure you want to pay from this card?',
	  'bidPayment.count_bay_fixprice': 'Count: ',
    'bidPayment.count_bay_fixprice_visits': 'Visits count: ',
    'bidPayment.add': 'Add new card',
    'bidPayment.remove': 'Remove',
    'bidPayment.activated': 'Activated',
    'connect.success': 'Succeed!',
    'lot_sidebar.profile': 'Profile',
    'lot.info': 'As soon as you make a charitable donation, a Meet For Charity employee will contact you and coordinate all the details of the meeting that are convenient for you. All arrangements are made through an employee of Meet For Charity.\ n Meet For Charity participants meet in city cafes and restaurants, unless otherwise specified in the description of the lot.\ n Meetings usually take an hour/an hour and a half, but you can always arrange on the spot.',
    'lot.info.title': 'How is the meeting going',
    'lot.complete': 'This auction has already been completed. You can leave a request for a second meeting with the hero.',
    'lot.complete_last_bid': 'Auction is completed. Amount collected',
    'person.tell_us': 'Tell us about<br />the meeting',
    'person.expiration': 'Until the end of the auction',
    'person.overbid': 'You’ve been overbid',
    'person.leading_bid': 'Your bid is in the lead',
    'person.place_bid': 'Place a bid',
    'contacts_form.message_sent': 'Your message was sent!',
    'contacts_form.write_message': 'Write a message',
    'contacts_form.name': 'Name',
    'contacts_form.email_or_phone': 'Email or telephone',
    'contacts_form.phone': 'Phone',
    'contacts_form.message': 'Message',
    'contacts_form.error': 'Something went wrong, try again later...',
    'preview_list.see_all_news': 'See all news items',
    'fund_donation_container.participants_supported': 'Participants, which have supported the foundation',
    'fund_donation_container.show_more': 'Show more',
    'fund_donation.may_26': 'May 26',
    'fund_donation_stats.amount': 'The amount collected for the foundation is',
    'fund_donation_stats.no_funds': 'No funds have been collected for the foundation yet',
    'mobile_menu.auctions': 'Auctions',
    'mobile_menu.art': 'Art',
    'mobile_menu.fixedprices': 'Fix lots',
    'mobile_menu.help': 'Help!',
    'mobile_menu.foundations': 'Foundations',
    'mobile_menu.participants': 'Participants',
    'mobile_menu.news': 'News',
    'mobile_menu.contacts': 'Contacts',
    'mobile_menu.giftcard': 'Gift Card',
    'mobile_menu.become_participant': 'Offer a lot',
    'mobile_menu.settings': 'Settings',
    'mobile_menu.logout': 'Logout',
    'mobile_menu.login': 'Login',
    'mobile_menu.aboutus': 'About us',
    'payment_fallback.success': 'Lot payment was<br />successfully carried out!',
    'payment_fallback.home': 'To Home Page',
    'payment_fallback.foundation': 'Foundation',
    'payment_fallback.sum': 'Donation sum',
    'payment_callback.heading': 'Heading',
    'payment_callback.email': 'Your email',
    'payment_callback.enter_email': 'Enter your email address',
    'payment_callback.email_format': 'Incorrect format for an email address',
    'payment_form.pay': 'Pay',
    'payment_error.error': 'An error occurred during the execution of your donation',
    'payment_error.try_again': 'Try again',
    'fixedlot.place_order': 'Get lot',//'Make appointment',
    'fixedlot.place_order_external': 'Get',
    'fixedlot.place_visit': 'Get visit',
    'fixedlot.send_request': 'Send request',
    'fixedlot.expert_text': 'These lots are available at a fixed cost',
    'fixedlot.price': 'Lot price',
    'fixedlot.left': 'Left',
    'art.expert_text': 'These lots are provided by artists and artists for the benefit of charity',
    'footer.offer': 'Offer',
    'footer.about': 'About Us',
    'footer.user_agreement': 'User Agreement',
    'footer.noteNKO': 'Note for non-profit organizations',
    'footer.policy': 'Privacy policy',
    'footer.policy-security-payment': 'Payment Security Policy. Acquiring',
    'footer.auctions': 'Auctions',
    'footer.fixedprices': 'Fix price lots',
    'footer.foundations': 'Foundations',
    'footer.participants': 'Participants',
    'footer.news': 'News',
    'footer.contacts': 'Contacts',
    'footer.giftcard': 'Gift Card',
    'footer.partners': 'Partners',
    'footer.we_are_on': 'We are on',
    'footer.vk': 'Вконтакте',
    'footer.twitter': 'Twitter',
    'footer.youtube': 'YouTube',
    'footer.download_app': 'Download the mobile app',
    'footer.telegram': 'Telegram',
    'footer.subscription_success': 'Subscription successful!',
    'footer.subscribe': 'Subscribe to our newsletter',
    'about.about': 'About us',
    'sign_in.login': 'Login',
    'sign_in.phone': 'Telephone',
    'sign_in.mail': ' Email address',
    'sign_in.phone_or_mail': 'Your phone number',
    'sign_in.confirmation_code': 'Confirmation code',
    'sign_in.name': 'Name',
    'sign_in.surname': 'Surname',
    'sign_in.preferred_methods': 'Preferred communication methods',
    'sign_in.email': 'E-mail',
    'sign_in.phone': 'Phone',
    'sign_in.sms': 'SMS',
    'sign_in.telegram': 'Telegram',
    'sign_in.whatsapp': 'WhatsApp',
    'sign_in.agreement_personal_1': 'I consent',
    'sign_in.agreement_personal_2': 'to the processing of the specified personal data for the purpose of participating in events held within the framework of',
    'sign_in.agreement_personal_3': 'the Meet For Charity Program',
    'sign_in.agreement_mailing_1': 'I agree to receive information about the activities, initiatives and events held within the framework of',
    'sign_in.agreement_mailing_2': 'the Meet For Charity Program',
    'sign_in.agreement_terms_1': 'By clicking next, I accept the terms of',
    'sign_in.agreement_terms_2': 'the User Agreement,',
    'sign_in.agreement_terms_3': 'the Meet For Charity Program',
    'sign_in.agreement_terms_4': 'and agree to ',
    'sign_in.agreement_terms_5': 'the Privacy Policy',
    'profile.meet': 'Meet',
    'profile.auctions_won': 'Auctions won',
    'profile.organize_meeting': 'Organize a meeting',
    'profile.tell_about_meeting': 'Tell us about your meeting',
    'profile.meetings': 'Your meetings',
    'profile.win_meeting': 'Win the meeting of your dreams',
    'profile.choose_auction': 'Choose the auction featuring a hero that interests you and place a bid.',
    'profile.see_auctions': 'See auctions',
    'profile.active_auctions': 'Active auctions',
    'profile.bid_history': 'Bid history',
    'static.last_modified': 'Date of last modification',
    'contacts.address': 'Russia, 127051, Moscow, Trubnaja ul., 17/4c2, ofis 202,409',
    'contacts.we_are_on': 'We are on',
    'contacts.lot_questions': 'Regarding the organization of meetings based on the results of auctions: ',
    'contacts.coop_questions': 'For questions about cooperation: ',
    'contacts.funds_questions': 'For questions about connecting funds: ',
    'contacts.events_questions': 'For organizing charity events: ',
    'contacts.lot_offer': 'If you want to offer a lot: ',
    'contacts.twitter': 'Twitter',
    'contacts.youtube': 'YouTube',
    'contacts.if_you_have': 'If you have any questions about the operation of the site, application, auction mechanics, lots or any other issue, write to us:',
    'contacts.write': 'Write',
    'home.see_all_auctions': 'See all auctions',
    'pay.pay': 'Pay',
    'pay.card': 'Pay by card',
    'pay.do_payment': 'Make payment',
    'members.more': 'See more',
    'members.wantToMeet': 'Want to meet',
    'members.expert_text': 'These lots took part in the Meet For Charity charity auctions. If you want to meet one of them, leave a request in the lot card.',
    'lot_list_index.loading': 'Loading',
    'lot_list_index.more': 'See more',
    'funds.collected': 'collected',
    'funds.more': 'Show more',
    'funds.registration': 'Registration for funds',
    'lot.last_bid': 'Previous bid',
    'lot.next_bid': 'Next bid',
    'lot.raise_bid': 'Raise the bid',
    'lot.place_bid': 'Place a bid',
    'lot.make_first_bid': 'Make the first bid',
    'lot.fixed_price': 'Fixed price',
    'lot.fixed_price_external': 'Price',
    'lot.total_few': 'Made',
    'lot.total_many': 'Made',
    'lot.left': 'Lots left:',
    'lot.leftVisit': 'Available visits left:',
    'lot.startBid': 'Start bid',
    'lot.bidStep': 'Minimum bid step',
    'lot.startDate': 'Bids start date',
    'lot.closeDate': 'Bids end date',
    'fixedlot.request_sent': 'Your request was sent!',
    'lot.follow': 'Track the auction',
    'lot.you_might': 'You might be interested in',
    'lot.moneySentTo': 'The funds collected as a result of the auction will be sent to the fund',
    'lot.auctionExtends': 'The auto-renewal mechanism has been launched! <br /> When placing a bid in the last 15 minutes <br />of the auction, it will be extended by 15 minutes.',
    'lot.code': 'Lot code:',
    'fund.active_auctions': 'Active auctions',
    'fund.participants_supported': 'Participants, which have already supported the foundation in lots',
	'fund.fixedpricelots_participants_supported': 'Participants, which have already supported the foundation in fixedprice lots',
    '404.message': 'Such a page does<br />not exist',
    '403.message': 'this page is available only for<br />authorized users',
    'partners.partners': 'Partners',
    'partners.write_us': 'If you have any suggestions for a collaboration or want to become one of our partners, write us',
    'comments_index.comments': 'Comments',
    'comments_index.more': 'Show more',
    'comments_index.leave_comment': 'Leave a comment',
    'comments_index.write_comment': 'Write a comment',
    'search.search': 'Search',
    'search.auction': 'Auction',
    'search.fixedpricelots': 'Shop',
    'search.participant': 'Participant',
    'search.foundation': 'Foundation',
    'search.no_results': 'No results found for your search',
    'member.with_participation_of': 'With the participation of',
    'member.with_participation_of_lot': 'With the participation of lot',
    'member.were_collected': 'were collected',
    'member.nothing_collected_1': 'Nothing yet has been collected with the participation of',
    'member.nothing_collected_2': '',
    'member.inform_me': 'Inform me about future auctions',
    'member.active_auction': 'Active auction',
    'member.no_active_auctions': 'There are no active auctions',
    'member.previous_auctions': 'Previous auctions',
    'person.summ_donated': 'With your help, collected ',
    'person_about_me.summ_donated': 'picked with your help',
    'person.summ_not_donated': 'No funds have been collected with you yet',
    'categories_index.all_categories': 'All categories',
    'cardlist.remove': 'remove',
    'cardlist.add': 'Add payment card',
    'regions.title': 'Select country',
    'regions.disclaimer': 'Please translate me properly "Чтобы начать делать ставки, выберите страну, с людьми из которой вы хотите встретиться"',
    'regions.setCountryPlaceholder': 'Select country',
    'regions.setLanguagePlaceholder': 'Select language',
    'regions.done': 'Done',
    'regions.usegiftcard': 'Use gift card',
    'email_popup.add_email': 'Add your email address',
    'email_popup.dont_show': 'Do not show again',
    'email_popup.done': 'Done',
    'phone_confirm.confirm': 'Confirm your phone number',
    'phone_confirm.done': 'Done',
    'phone_confirm.error': 'Phone format error',
    'time_confirm.error': 'Time format error',
    'giftcardsbuy.send': 'send',
    'giftcardsbuy.buy_giftcard': 'Buy a gift card',
    'giftcardsbuy.ecard': 'Electronic card',
    'giftcardsbuy.mcard': 'Physical card',
    'giftcardsbuy.fixprice': 'Fixed amount',
    'giftcardsbuy.non_fixprice': 'Unfixed amount',
    'giftcardsbuy.choose_denom': 'Select denomination',
    'giftcardsbuy.attention': 'Attention! The fixed amount gift card is a one-time payment.',
    'giftcardsbuy.sender': 'Sender',
    'giftcardsbuy.name': 'Name',
    'giftcardsbuy.email': 'Email',
    'giftcardsbuy.recipient': 'Recipient',
    'giftcardsbuy.phone': 'Phone',
    'giftcardsbuy.comment': 'Commentary',
    'giftcardsbuy.when': 'When to deliver the card?',
    'giftcardsbuy.now': 'Now',
    'giftcardsbuy.specify_date': 'Specify the date',
    'giftcardsbuy.pay': 'Pay',
    'giftcardsbuy.required_phone_email': 'Please enter phone or email in valid format',
    'giftcardsbuy.required': 'Required',
    'giftcardsbuy.required_format': 'Please enter field in valid format',
    'giftcardsbuy.required_denomination': 'Please enter denomination of gift card',
    'giftcardsbuy.no_giftcards': 'Cards with this denomination are not available',
    'giftcardsbuy.sum': 'Amount',
    'giftcardsbuy.notification_channel': 'Channel for card delivery notification',
    'giftcardsbuy.now': 'Now',
    'choose.role.user': 'I am user',
    'choose.role.person': 'I am the hero of the auction',
    'download.person_data': 'Download form data',
    'person_data_form.create': 'Create',
    'person_data_form.agree': 'I agree',
    'person_data_form.not_agree': 'I not agree',
    'person_profile.passport_organization': 'That gave out',
    'person_profile.passport_series': 'Series',
    'person_profile.passport_number': 'Number',
    'person_approval.request': 'Your reply has been sent',
    'request_of_user.reselect_date.error': 'Write the reason for the date change',
    'date_selection_rounds_expired.error': 'Write why it was not possible to choose a date',
    'national_card.only': 'Only cards issued by banks of the Russian Federation are accepted for payment of donations',
    'national_card.change': 'If you have used a card of a foreign issuer, please contact the manager to choose another payment method',
    'moskow_time': 'moskow time',
    'report_minust': 'Report Ministry of Justice'
  },
  'ru': {
    'common.and': 'и',
    'common.bid': 'ставка',
    'common.bids_few': 'ставки',
    'common.bids_many': 'ставок',
    'common.day': 'день',
    'common.days_few': 'дня',
    'common.days_many': 'дней',
    'common.foundation_instrumental_case': 'фондом',
    'common.foundations_instrumental_case': 'фондами',
    'common.foundations_instrumental_case-charity': 'благотворительными фондами',
    'common.hour': 'час',
    'common.hours_few': 'часа',
    'common.hours_many': 'часов',
    'connect.subtitle': 'Чтобы подключить свой фонд к платформе и получить возможность размещать лоты, заполните анкету. Мы рассмотрим её в течение 7 рабочих дней.',
    'connect.thanks_for': 'Спасибо за вашу заявку!',
    'connect.we_contact': 'Ваша анкета будет рассмотрена в течение 7 рабочих дней, в случае ее одобрения или возникновения вопросов мы свяжемся с вами.',
    'connect.go_main': 'Перейти на главную',
    'connect.send': 'Отправить анкету на рассмотрение',
    'connect.have_errors': 'В форме обнаружены ошибки',
    'connect.application': 'Анкета для подключения фонда',
    'connect.step': 'Шаг',
    'connect.general_information': 'Общая информация о фонде',
    'connect.representative': 'Контакты представителя',
    'connect.entity': 'Юридическая информация',
    'connect.suggested_lots': 'Ваш список потенциальных лотов',
    'hero.for_charity': 'собрано на&nbsp;благотворительность за&nbsp;9&nbsp;лет',
    'hero.good_excuse': 'Крупнейший в России благотворительный аукцион встреч с известными людьми. Встречайся и помогай!',
    'profile_report.report_sent': 'Ваш отчет успешно отправлен!',
    'profile_report.report_about': 'Отчёт о встрече с',
    'profile_report.your_impressions': 'Ваши впечатления',
    'profile_report.error': 'Что-то пошло не так, попробуйте позже...',
    'profile_report.send': 'Отправить',
    'profile_report.delete_photo': 'Удалить фото',
    'profile_report.delete_approval_form': 'Удалить форму',
    'profile_report.add_photo': 'Добавить фото',
    'profile_report.you_must_fill': 'Необходимо написать текст отчета',
    'profile_edit.back': 'Назад',
    'profile_edit.save': 'Сохранить',
    'profile_edit.login': 'Изменить номер телефона',
    'profile_edit.name': 'Имя',
    'profile_edit.middlename': 'Отчество',
    'profile_edit.surname': 'Фамилия',
    'profile_edit.field_required': 'Не указано значение поля',
    'profile_edit.invalid_date': 'Неверная дата',
    'profile_edit.phone_format': 'Телефон должен быть вида 7ХХХХХХХХХХ',
    'profile_edit.email_format': 'Email должен быть вида something@exxample.com',
    'profile_edit.preferred_methods': 'Предпочтительные каналы связи',
    'profile_edit.birthday': 'Дата рождения',
    'profile_edit.birthday.0': 'Январь',
    'profile_edit.birthday.1': 'Февраль',
    'profile_edit.birthday.2': 'Март',
    'profile_edit.birthday.3': 'Апрель',
    'profile_edit.birthday.4': 'Май',
    'profile_edit.birthday.5': 'Июнь',
    'profile_edit.birthday.6': 'Июль',
    'profile_edit.birthday.7': 'Август',
    'profile_edit.birthday.8': 'Сентябрь',
    'profile_edit.birthday.9': 'Октябрь',
    'profile_edit.birthday.10': 'Ноябрь',
    'profile_edit.birthday.11': 'Декабрь',
    'profile_edit.passport': 'Паспорт:',
    'profile_edit.month': 'Месяц',
    'profile_edit.day': 'день',
    'profile_edit.email': 'E-mail',
    'profile_edit.phone': 'Телефон',
    'profile_edit.sms': 'SMS',
    'profile_edit.telegram': 'Telegram',
    'profile_edit.whatsapp': 'WhatsApp',
    'profile_edit.telegramId': 'Telegram ID',
    'profile_edit.telegramName': 'Telegram - Имя пользователя',
    'profile_sidebar.you_donated': 'Вы пожертвовали',
    'profile_sidebar.you_supported': 'Вы поддержали',
    'profile_sidebar.you_did_not_donate': 'Вы ничего<br />не пожертво&shy;вали',
    'profile_sidebar.unpaid_lots': 'Неоплаченные лоты',
    'profile_sidebar.paid_fixedpricelots': 'Покупки фиксированных лотов',
    'profile_sidebar.pay': 'Оплатить',
    'profile_sidebar.pay_button': 'Сделать ставку',
    'profile_sidebar.not_won': 'Похоже, пока вы не выиграли ни одного аукциона. Время сделать победную ставку и поддержать тех, кто в этом нуждается.',
    'person_profile_sidebar.you_did_not_support': 'Вы еще<br />не поддержи&shy;вали фонды',
    'person_profile.birthday': 'День рождения',
    'person_profile.birthday.0': 'Январь',
    'person_profile.birthday.1': 'Февраль',
    'person_profile.birthday.2': 'Март',
    'person_profile.birthday.3': 'Апрель',
    'person_profile.birthday.4': 'Май',
    'person_profile.birthday.5': 'Июнь',
    'person_profile.birthday.6': 'Июль',
    'person_profile.birthday.7': 'Август',
    'person_profile.birthday.8': 'Сентябрь',
    'person_profile.birthday.9': 'Октябрь',
    'person_profile.birthday.10': 'Ноябрь',
    'person_profile.birthday.11': 'Декабрь',
    'person_profile.save': 'Данные персоны сохранены',
    'person_approval.request': 'Ваш ответ отправлен',
    'claim.become_participant': 'Предложить лот',
    'claim.application_accepted': 'Ваша заявка принята!',
    'claim.few_words': 'Напишите пару слов о себе',
    'claim.write_about': 'Напишите о себе',
    'claim.send': 'Отправить',
    'claim.error': 'Что-то пошло не так, повторите попытку позже...',
    'help.donation_notice': 'Благодарим вас за ваше пожертвование',
    'help.donation_text': 'Благодарим вас за ваше пожертвование',
    'help.whom': 'Кому мы благодарны',
    'help.help': 'Помогаю!',
    'select.subject': 'Тема сообщения',
    'header.auctions': 'Аукционы',
    'choose.role.user': 'Я меценат',
    'choose.role.person': 'Я герой аукциона',
    'header.arts': 'Art',
    'header.about.me': 'Обо мне',
    'header.ducuments': 'Документы',
    'header.reporting': 'Отчетность',
    'header.visits': 'Встречи',
    'header.fixedprices': 'Fix-лоты',
    'header.help': 'Помогаю!',
    'header.foundations': 'Фонды',
    'header.participants': 'Ранее в аукционе',
    'header.news': 'Новости',
    'header.massmedia': 'СМИ о нас',
    'header.contacts': 'Контакты',
    'header.giftcard': 'Подарочный сертификат',
    'header.become_participant': 'Предложить лот',
    'header.settings': 'Настройки',
    'header.profile': 'Личный кабинет',
    'header.logout': 'Выйти',
    'header.login': 'Войти',
    'header.aboutus': 'О нас',
    'timer.repeat_in': 'Мы отправили код подтверждения на указанный логин. Его можно отправить повторно через',
    'timer.resend': 'Выслать код повторно',
    'timer.back': 'Назад',
    'timer.auction_finish': 'До конца аукциона',
    'timer.auction_completed': 'Аукцион завершен',
    'sidebar_share.share': 'Поделиться:',
    'sidebar_share.vk': 'ВКонтакте',
    'sidebar_share.twitter': 'Твиттер',
    'form.send': 'Отправить',
    'preview_list.we_have': 'Мы сотрудничаем с более чем',
    'preview_list.among_them': 'среди них',
    'preview_list.see_all': 'Посмотреть все фонды',
    'bid_history.you': 'Вы',
    'bid_history.show_more': 'Показать ещё',
    'bid.bid_sent': 'Операция осуществлена успешно!', //Ваша ставка успешно отправлена
    'bid.bid_fail': 'Ошибка операции',
    'bid.bid_na': 'Ставки недоступны',
    'bid.make_bid': 'Сделать ставку',
    'bid.make_purchase': 'Получить лот',
    'bid.lot': 'Лот',
    'bid.login_required': 'Сначала войдите в свой аккаунт',
    'bid.bid': 'Ставка',
    'bid.error': 'Что-то пошло не так, попробуйте позже...',
    'bid.make_bid_anonymously': 'Сделать ставку анонимно',
    'bid.follow_auction': 'Отслеживать аукцион',
    'bid.choose_bid': 'Укажите вашу ставку',
    'bid.invalid_giftcard': 'Выбранный подарочный сертификат недействителен',
    'bid.accept_agreements': 'Согласитесь с условиями Оферты и Правилами пользования сертификатом',
    'bid.accept_agreements_offer': 'Согласитесь с условиями Оферты',
    'bid.accept_agreements_giftcards': ' и Правилами пользования сертификатом',
    'bid.choose_payment_method': 'Выберите способ оплаты',
    'bid.bid_too_small': 'Ваша ставка не может быть ниже',
    'bid.bid_recommendation':'Ставка должна быть не менее',
    'bid.agreement_title': 'Уважаемый пользователь!',
    'bid.agreement_text': 'При привязке карты с Вас будет списана небольшая сумма денежных средств (не более 2 руб.), которая в дальнейшем будет возвращена, одновременно с этим будет списана указанная сумма за покупку.',
    'bid.proceed': 'Продолжить',
    'bid.select_payment': 'Выберите способ внесения пожертвования',
    'bid.charge_only_win_bid': '*Списание средств произойдёт только в случае победы в аукционе.',
    'bid.we_become_better': 'Мы становимся лучше для вас.',
    'bid.new_payment_method': 'Поэтому Meet For Charity переходит на новую платёжную систему. Добавьте карту и оплачивайте лоты быстро и легко.',
    'bid.make_payment': 'Сделать пожертвование',
    'bid.select_card': 'Выберите карту',
    'bid.zero_giftcard': 'Баланс сертификата равен нулю',
    'bidPayment.confirm_delete_card': 'Вы действительно хотите удалить привязанную карту?',
    'bidPayment.confirm_pay_from_card': 'Вы действительно хотите оплатить выбранной картой?',
	'bidPayment.count_bay_fixprice': 'Количество: ',
  'bidPayment.count_bay_fixprice_visits': 'Количество встреч: ',
    'bidPayment.add': 'Добавить карту',
    'bidPayment.remove': 'Удалить',
    'bidPayment.activated': 'Подключено',
    'connect.success': 'Успешно!',
    'lot_sidebar.profile': 'Профиль',
    'person.tell_us': 'Расскажите<br />о встрече',
    'person.expiration': 'До завершения',
    'person.overbid': 'Вашу ставку перебили',
    'person.leading_bid': 'Ваша ставка лидирует',
    'person.place_bid': 'Сделать ставку',
    'contacts_form.message_sent': 'Ваше сообщение отправлено!',
    'contacts_form.write_message': 'Написать сообщение',
    'contacts_form.name': 'Имя',
    'contacts_form.email_or_phone': 'Почта или телефон',
    'contacts_form.phone': 'Телефон',
    'contacts_form.message': 'Сообщение',
    'contacts_form.error': 'Что-то пошло не так, повторите попытку позже...',
    'preview_list.see_all_news': 'Посмотреть все новости',
    'fixedlot.place_order': 'Получить лот',//'Назначить встречу',
    'fixedlot.place_order_external': 'Получить',
    'fixedlot.place_visit': 'Встретиться',
    'fixedlot.send_request': 'Оставить заявку',
	  'fixedlot.expert_text': 'Данные лоты доступны по фиксированной стоимости',
    'fixedlot.price': 'Цена лота',
    'fixedlot.left': 'Осталось',

    'fixedlot.request_sent': 'Ваша заявка отправлена!',
    'art.expert_text': 'Данные лоты предоставлены художниками и деятелями искусства в пользу благотворительности',
    'fund_donation_container.participants_supported': 'Участники, которые уже поддержали фонд',
    'fund_donation_container.show_more': 'Показать ещё',
    'fund_donation.may_26': '26 мая',
    'fund_donation_stats.amount': 'В пользу фонда собрано',
    'fund_donation_stats.no_funds': 'Пока ничего не собрано в пользу фонда',
    'mobile_menu.auctions': 'Аукционы',
    'mobile_menu.arts': 'Art',
    'mobile_menu.fixedprices': 'Fix-лоты',
    'mobile_menu.help': 'Помогаю!',
    'mobile_menu.foundations': 'Фонды',
    'mobile_menu.participants': 'Ранее в аукционе',
    'mobile_menu.news': 'Новости',
    'mobile_menu.contacts': 'Контакты',
    'mobile_menu.giftcard': 'Подарочный сертификат',
    'mobile_menu.become_participant': 'Предложить лот',
    'mobile_menu.settings': 'Настройки',
    'mobile_menu.logout': 'Выход',
    'mobile_menu.login': 'Вход',
    'mobile_menu.aboutus': 'О нас',
    'payment_fallback.success': 'Оплата лота прошла успешно!',
    'payment_fallback.home': 'На главную',
    'payment_fallback.foundation': 'Фонд',
    'payment_fallback.sum': 'Сумма пожертвования',
    'payment_callback.heading': 'Заголовок',
    'payment_callback.email': 'Ваш Email',
    'payment_callback.enter_email': 'Введите свой контактный email адрес',
    'payment_callback.email_format': 'Неверный формат email адреса',
    'payment_form.pay': 'Оплатить',
    'payment_error.error': 'Возникла ошибка при внесении пожертвования',
    'payment_error.try_again': 'Повторить',
    'footer.offer': 'Оферта',
    'footer.about': 'О нас',
    'footer.user_agreement': 'Пользовательское соглашение',
    'footer.noteNKO': 'Памятка для НКО',
    'footer.policy': 'Политика конфиденциальности',
    'footer.policy-security-payment': 'Политика безопасности платежей. Эквайринг',
    'footer.connect': 'Хочу подключиться',
    'footer.auctions': 'Аукционы',
    'footer.fixedprices': 'Fix price lots',
    'footer.foundations': 'Фонды',
    'footer.participants': 'Участники',
    'footer.news': 'Новости',
    'footer.contacts': 'Контакты',
    'footer.giftcard': 'Подарочный сертификат',
    'footer.partners': 'Партнеры',
    'footer.we_are_on': 'Мы в',
    'footer.vk': 'Вконтакте',
    'footer.twitter': 'Твиттере',
    'footer.youtube': 'YouTube',
    'footer.download_app': 'Скачайте мобильное приложение',
    'footer.telegram': 'Telegram',
    'footer.subscription_success': 'Подписка оформлена!',
    'footer.subscribe': 'Подписаться на новости',
    'about.about': 'О нас',
    'sign_in.login': 'Вход',
    'sign_in.registrationLogin': 'Войти / Зарегистрироваться',
    'sign_in.mail': 'Email',
    'sign_in.phone': 'Телефон',
    'sign_in.phone_or_mail': 'Ваш номер телефона',
    'sign_in.confirmation_code': 'Код подтверждения',
    'sign_in.send_confirmation_code': 'Выслать код подтверждения',
    'sign_in.name': 'Имя',
    'sign_in.surname': 'Фамилия',
    'sign_in.preferred_methods': 'Предпочтительные каналы связи',
    'sign_in.email': 'E-mail',
    'sign_in.phone': 'Телефон',
    'sign_in.sms': 'SMS',
    'sign_in.telegram': 'Telegram',
    'sign_in.whatsapp': 'WhatsApp',
    'sign_in.agreement_personal_1': 'Даю согласие',
    'sign_in.agreement_personal_2': 'на обработку указанных персональных данных в целях участия в мероприятиях, проводимых в рамках',
    'sign_in.agreement_personal_3': 'Программы Meet For Charity',
    'sign_in.agreement_mailing_1': 'Согласен получать информационное оповещение о деятельности, инициативах и мероприятиях, проводимых в рамках',
    'sign_in.agreement_mailing_2': 'Программы Meet For Charity',
    'sign_in.agreement_terms_1': 'Нажимая далее, я принимаю условия ',
    'sign_in.agreement_terms_2': 'Пользовательского соглашения,',
    'sign_in.agreement_terms_3': 'Программы Meet For Charity',
    'sign_in.agreement_terms_4': 'и соглашаюсь с ',
    'sign_in.agreement_terms_5': 'Политикой конфиденциальности',
    'profile.meet': 'Встретиться',
    'profile.auctions_won': 'Выигранные аукционы',
    'profile.organize_meeting': 'Договариваемся о встрече',
    'profile.tell_about_meeting': 'Рассказать о встрече',
    'profile.meetings': 'Ваши встречи',
    'profile.win_meeting': 'Выиграйте встречу своей мечты',
    'profile.choose_auction': 'Выберите аукцион с интересующим вас человеком и сделайте ставку.',
    'profile.see_auctions': 'Посмотреть аукционы',
    'profile.active_auctions': 'Активные аукционы',
    'member.previous_auctions': 'Прошлые аукционы',
    'profile.bid_history': 'История ставок',
    'static.last_modified': 'Дата последнего изменения',
    'contacts.address': 'Россия, 127031, г. Москва, ул. Рождественка д. 5/7, стр. 2, помещ. 4А/5',
    'contacts.phone': 'Контактный номер: ',
    'contacts.we_are_on': 'Мы в',
    'contacts.lot_questions': 'По вопросам организации встреч и итогам аукционов: ',
    'contacts.coop_questions': 'По вопросам сотрудничества: ',
    'contacts.funds_questions': 'По вопросам подключения фондов: ',
    'contacts.events_questions': 'По вопросам организации благотворительных мероприятий: ',
    'contacts.lot_offer': 'Если вы хотите предложить лот: ',
    'contacts.twitter': 'Твиттере',
    'contacts.youtube': 'YouTube',
    'contacts.if_you_have': 'Если у вас есть вопросы о работе сайта, приложения, механике аукционов, лотах или любой другой вопрос, напишите нам:',
    'contacts.write': 'Написать',
    'home.see_all_auctions': 'Посмотреть все аукционы',
    'pay.pay': 'По реквизитам',
    'pay.card': 'Оплатить банковской картой',
    'pay.do_payment': 'Оплатить',
    'members.more': 'Посмотреть ещё',
    'members.wantToMeet': 'Хочу встретиться',
    'members.expert_text': 'Данные лоты принимали участие в благотворительных аукционах Meet For Charity. Если вы хотите встретиться с одним из них, оставьте заявку в карточке лота.',
    'lot_list_index.loading': 'Загрузка',
    'lot_list_index.more': 'Посмотреть ещё',
    'funds.collected': 'собрано',
    'funds.more': 'Показать ещё',
    'funds.registration': 'Регистрация для фондов',
    'lot.last_bid': 'Последняя ставка',
    'lot.complete_last_bid': 'Аукцион завершен. Собранная сумма',
    'lot.next_bid': 'Следующая ставка',
    'lot.raise_bid': 'Поднять ставку',
    'lot.place_bid': 'Сделать ставку',
    'lot.make_first_bid': 'Сделайте ставку первым',
    'lot.fixed_price': 'Фиксированная ставка',
    'lot.fixed_price_external': 'Стоимость',
    'lot.total_few': 'Сделана',
    'lot.total_many': 'Сделано',
	  'lot.left': 'Осталось свободных лотов:',
    'lot.leftVisit': 'Осталось доступных встреч:',
    'lot.complete': 'Этот аукцион уже завершен. Вы можете оставить заявку на повторную встречу с героем.',
    'lot.startBid': 'Начальная ставка',
    'lot.bidStep': 'Минимальный шаг ставки',
    'lot.startDate': 'Начало подачи ставок',
    'lot.closeDate': 'Окончание подачи ставок',
    'lot.follow': 'Cледить за аукционом',
    'lot.you_might': 'Вас могут заинтересовать',
    'lot.moneySentTo': 'Собранные по итогам аукциона средства будут направлены в фонд',
    'lot.auctionExtends': 'Запущен механизм автопродления!<br />При совершении ставки в последние 15 минут <br />аукциона, он будет продлен на 15 минут.',
    'lot.moneySentToMFC': 'Собранные по итогам аукциона средства будут направлены на развитие благотворительности в России и проекта',
    'lot.info': 'Как только вы сделаете благотворительное пожертвование, сотрудник Meet For Charity свяжется с вами и согласует все детали встречи, удобные для Вас. Все договоренности происходят через сотрудника Meet For Charity.\n Участники Meet For Charity встречаются в городских кафе и ресторанах, если иное не оговорено в описании лота.\n Обычно встречи занимают час/полтора, но вы всегда можете договориться на месте.',
    'lot.info.title': 'Как проходит встреча',
    'lot.code': 'Код лота:',
    'fund.active_auctions': 'Активные аукционы',
    'fund.participants_supported': 'Участники, которые уже поддержали фонд в аукционах',
    'fund.fixedpricelots_participants_supported': 'Участники, которые уже поддержали фонд в фиксированных лотах',
    '404.message': 'такой страницы не<br />существует',
    '403.message': 'эта страница доступна только<br />авторизованным пользователям',
    'partners.partners': 'Партнеры',
    'partners.write_us': 'Если у вас есть предложения о сотрудничестве или вы хотите стать нашим партнером, напишите нам',
    'comments_index.comments': 'Комментарии',
    'comments_index.more': 'Показать ещё',
    'comments_index.leave_comment': 'Оставить комментарий',
    'comments_index.write_comment': 'Написать комментарий',
    'search.search': 'Поиск',
    'search.auction': 'Аукцион',
    'search.fixedpricelots': 'Shop',
    'search.participant': 'Участник',
    'search.foundation': 'Фонд',
    'search.no_results': 'По вашему запросу ничего не найдено',
    'support.project': 'Поддержать',
    'member.with_participation_of': 'C участием',
    'member.with_participation_of_lot': 'C участием лота',
    'member.were_collected': 'собрано',
    'member.nothing_collected_1': 'C участием',
    'member.nothing_collected_2': 'пока ничего не собрано',
    'member.inform_me': 'Сообщить о будущих аукционах',
    'member.active_auction': 'Сейчас персона участвует в аукционах',
    'member.no_active_auctions': 'Нет активных аукционов',
    'person.summ_donated': 'С вашей помощью собрано ',
    'person_about_me.summ_donated': 'собрано c вашей помощью',
    'person.summ_not_donated': 'С вами пока не собрано средств',
    'categories_index.all_categories': 'Все категории',
    'cardlist.remove': 'удалить',
    'cardlist.add': 'Добавить карту',
    'regions.title': 'Выбор страны',
    'regions.disclaimer': 'Чтобы начать делать ставки, выберите страну, с людьми из которой вы хотите встретиться',
    'regions.setCountryPlaceholder': 'Выберите страну',
    'regions.setLanguagePlaceholder': 'Выберите язык',
    'regions.done': 'Готово',
    'regions.usegiftcard': 'Использовать подарочную карту',
    'email_popup.add_email': 'Укажите свой email',
    'email_popup.dont_show': 'Больше не показывать',
    'email_popup.done': 'Готово',
    'phone_confirm.confirm': 'Подтвердите свой номер телефона',
    'phone_confirm.connection': 'Для подтверждения заявки на повторную встречу с героем оставьте ваш номер телефона. Мы скоро свяжемся с вами!',
    'phone_confirm.done': 'Готово',
    'phone_confirm.error': 'Укажите номер телефона в корректном формате',
    'time_confirm.error': 'Укажите время встречи в корректном формате',
    'time_confirm.connection': 'Укажите удобное для Вас время встречи на выбранную дату',
    'giftcardsbuy.send': 'Далее',
    'giftcardsbuy.buy_giftcard': 'Купить подарочную карту',
    'giftcardsbuy.ecard': 'Электронная карта',
    'giftcardsbuy.mcard': 'Физическая карта',
    'giftcardsbuy.fixprice': 'Фиксированная сумма',
    'giftcardsbuy.non_fixprice': 'Нефиксированная сумма',
    'giftcardsbuy.choose_denom': 'Выберите номинал',
    'giftcardsbuy.attention': 'Внимание! Подарочная карта с фиксированной суммой осуществляет единоразовую оплату.',
    'giftcardsbuy.sender': 'Отправитель',
    'giftcardsbuy.name': 'Имя',
    'giftcardsbuy.email': 'Email',
    'giftcardsbuy.recipient': 'Получатель',
    'giftcardsbuy.phone': 'Телефон',
    'giftcardsbuy.comment': 'Комментарий',
    'giftcardsbuy.when': 'Когда доставить карту?',
    'giftcardsbuy.now': 'Сейчас',
    'giftcardsbuy.specify_date': 'Указать дату',
    'giftcardsbuy.pay': 'Оплатить',
    'giftcardsbuy.required_phone_email': 'Необходимо заполнить телефон или email в корректном формате',
    'giftcardsbuy.required': 'Необходимо заполнить данное поле',
    'giftcardsbuy.required_format': 'Необходимо заполнить данное поле в корректном формате',
    'giftcardsbuy.required_denomination': 'Необходимо заполнить номинал карты',
    'giftcardsbuy.no_giftcards': 'Доступных карт данного типа нет в наличии',
    'giftcardsbuy.sum': 'Сумма',
    'giftcardsbuy.notification_channel': 'Канал для уведомления о доставке карты',
    'giftcardsbuy.now': 'Сейчас',
    'chooserole.error': 'Пожалуйста, выберите как вы хотите зайти',
    'download.person_data': 'Загрузить форму',
    'person_data_form.create': 'Создать',
    'person_profile.passport_organization': 'Кем',
    'person_profile.passport_series': 'Серия',
    'person_profile.passport_number': 'Номер',
    'person_data_form.agree': 'Я согласен',
    'person_data_form.not_agree': 'Я не согласен',
    'person_data_form.not_agree_comment': 'Если вы не согласны',
    'request_of_user.reselect_date.error': 'Напишите причину смены дат',
    'date_selection_rounds_expired.error': 'Заполните поле комментария',
    'national_card.only': 'Для оплаты пожертвований принимаются только карты, выпущенные банками РФ',
    'national_card.change': 'Если вы использовали карту иностранного эмитента, пожалуйста, свяжитесь с менеджером для выбора другого способа оплаты',
    'moskow_time': 'Время московское',
    'report_minust': 'Отчет Минюст',
    'visit_info_dates.person': 'Даты, предложенные Вами:',
    'visit_info_dates.user': 'Даты, предложенные персоной:',
    'visit_choosed_dates.person': 'Датa, выбранная меценатом:',
    'visit_choosed_dates.user': 'Датa, выбранная Вами:'
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/i18n/data.js